export const setStorage = (appId: string, type: string, data: any) => {
  let updatedData = data;
  if (data) {
    if (typeof data !== "string") {
      updatedData = JSON.stringify(data);
    }
    if (type) {
      localStorage.setItem(`Chatbot-${appId}-${type}`, updatedData);
    } else {
      localStorage.setItem(`Chatbot-${appId}`, updatedData);
    }
  } else {
    localStorage.removeItem(`Chatbot-${appId}-${type}`);
  }
};

export const getStorage = (appId: string, type: string | null) => {
  if (type) {
    return localStorage.getItem(`Chatbot-${appId}-${type}`);
  } else {
    return localStorage.getItem(`Chatbot-${appId}`);
  }
};

export const resetStorage = () => {
  let applicationId = getAppId();
  const activityId = getStorage(applicationId, "activityId");
  if (activityId) {
    localStorage.removeItem(`Chatbot-${applicationId}-activityId`);
    localStorage.removeItem(`Chatbot-${applicationId}`);
    localStorage.removeItem(`currentTab`);
    localStorage.removeItem(`Chatbot-${applicationId}-tab`);
    localStorage.removeItem(`Chatbot-${applicationId}-end-chat`);
  }
};

export const getAppId = (): string => {
  let appMgr = null;
  try {
    appMgr = window.getAppWindow();
    if (appMgr && appMgr.application) {
      return appMgr?.application?._id || "";
    } else {
      return "";
    }
  } catch (e: any) {
    return "";
  }
};
